import {
  FETCH_USER_DETAILS_START,
  FetchUserDetailsStartAction,
  FETCH_USER_DETAILS_SUCCESS,
  FetchUserDetailsSuccessAction
} from '../actions/action-types';
import { CurrentUserDTO } from '../../services/server-types';
import { CurrentUserState } from '../configure-store';

const EMPTY_STATE: CurrentUserDTO = {
  first: null,
  last: null,
  profileImage: null
};

export const currentUser = (state = EMPTY_STATE, action: FetchUserDetailsStartAction | FetchUserDetailsSuccessAction): CurrentUserState => {
  switch (action.type) {
    case FETCH_USER_DETAILS_START:
      return state;
    case FETCH_USER_DETAILS_SUCCESS:
      return action.userDetails;
    default:
      return state;
  }
};
